module.exports = __webpack_public_path__ + "fonts/Golos-Text_DemiBold.b46dc1b.woff";